import React from "react";

const formatTitleWithOptional = (title) => {
  if (!title) return ""; // or return a fallback string
  if (title.includes("(optional)")) {
    const [mainText, optionalText] = title.split("(optional)");
    return (
      <>
        {mainText}
        <i
          style={{
            fontStyle: "italic",
            color: "#000000",
            fontWeight: 400,
            fontSize: "14px",
          }}
        >
          (optional)
        </i>
      </>
    );
  }
  return title;
};
export default formatTitleWithOptional;
